import { EmployeesTable } from "components";

const Employees = () => {



    return (
        <EmployeesTable/>
    );

}
export default Employees;